import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { NgForm } from '@angular/forms';
import { AutoLogoutService } from './service/auto-logout.service';
import { Location } from "@angular/common";
import { Login } from './Model/Login';
import { Applicationcl } from './Model/Applicationcl';
import { environment } from 'src/environments/environment';
import { ForgotPassword } from './Model/ForgotPassword';
import { ServiceStatus } from './Model/ServiceStatus';
import { ResponseCode } from './CheckResponse';
import { MasterConfigrationService } from './service/MasterConfigrationService';
import { UserService } from './service/user.service';
import { PartyUser } from './Model/PartyUser';
import { CommonService } from './service/CommonService';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [ './app.component.css' ]
})
export class AppComponent implements OnInit {
  public URL: String = '';
  public ErrorMessee: string = "";
  public UserId: number = 0;
  public Menu: string = '';
  public IsProgressBarEnable: boolean = false;
  public RoleId: number = 0;

  public IsForgotPassword: boolean = false;
  public IsOTPReceived: boolean = false;
  timer = { s: 0, mn: 0 };
   isfirstlogin:number = 0;


  constructor (private _service: UserService, private router: Router, public login: Login, private AutoLogoutService: AutoLogoutService,
    location: Location, public oApplicationcl: Applicationcl, public oForgotPassword: ForgotPassword, private oMasterConfigrationService: MasterConfigrationService,
    public oPartyUser: PartyUser, public commonservice: CommonService,) {
    this.login.USERID = 0;
  }

  ngOnInit() {
    this.Menu = '';
    // let userid = localStorage.getItem("userid");
    // sessionStorage.setItem("userid", (userid == null ? "0" : userid));
    // let fullname = localStorage.getItem("fullname");
    // sessionStorage.setItem("fullname", (fullname == null ? "" : fullname));
    // let RoleId = "0";
    // RoleId = localStorage.getItem("RoleId")!;
    // sessionStorage.setItem("RoleId", RoleId == null ? "0" : RoleId);
    // sessionStorage.setItem("fullname", localStorage.getItem("fullname"));
    // sessionStorage.setItem("acccode", localStorage.getItem("acccode"));
    // if (parseInt(RoleId) > 2) {
    //   sessionStorage.setItem("loccode", localStorage.getItem("loccode")!);
    // } else { sessionStorage.setItem("loccode", "0"); }
    environment.token = localStorage.getItem( "token" );
    if (parseInt(sessionStorage.getItem("userid")!) > 0) {
      this.UserId = parseInt(sessionStorage.getItem("userid")!);
      this.RoleId = parseInt(sessionStorage.getItem("RoleId")!);
      this.login.USERID = this.UserId;
      this.login.FullName = sessionStorage.getItem( "fullname" )!;
      this.isfirstlogin = parseInt(localStorage.getItem( "isfirstlogin"));
    }
    // alert(this.login.USERID)
    if (this.login.USERID > 0) {
      localStorage.setItem('lastAction', Date.now().toString());
    }
  }


  signOut() {
    this.login.USERID = 0;
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigateByUrl('/');
  }

  ClickCancel() {
    this.ErrorMessee = "";
    document.getElementById('Login')!.click();
  }

  onSubmit(form: NgForm) {
    this.oApplicationcl.IsProgressBarEnable = true;
    this.oPartyUser.RequestSource = 'ClientWebApp';
    this._service.AuthenticatePartyLogin(this.oPartyUser).subscribe(
      data => {
        this.oApplicationcl.IsProgressBarEnable = false;
        let oServiceStatus: ServiceStatus = data;
        if (oServiceStatus.Status == ResponseCode.Success.toString()) {
          this.oPartyUser = oServiceStatus.RecordDetail;
          this.UserId = this.oPartyUser.CON_USERID;
          sessionStorage.setItem("userid", this.UserId.toString());
          sessionStorage.setItem("fullname", this.oPartyUser.ACC_NAME);
          sessionStorage.setItem( "acccode", this.oPartyUser.ACC_CODE );
          sessionStorage.setItem( "isfirstlogin", this.oPartyUser.IS_FIRSTLOGIN.toString());
          sessionStorage.setItem( "RoleId", "0" );
          localStorage.setItem( "loginuser", this.oPartyUser.MOB_NUMBER );
          localStorage.setItem( "isfirstlogin", this.oPartyUser.IS_FIRSTLOGIN.toString() );
          sessionStorage.setItem( "loccode", "0" );
          environment.token = oServiceStatus.RecordNo;
          localStorage.setItem( "token", environment.token );
          // localStorage.setItem("userid", this.UserId.toString());
          // localStorage.setItem("fullname", this.oPartyUser.ACC_NAME);
          // localStorage.setItem("RoleId", "0");
          // localStorage.setItem("loccode", "0");
          // localStorage.setItem("acccode", this.oPartyUser.ACC_CODE);
          this.ErrorMessee = '';
          this.oApplicationcl.IsProgressBarEnable = false;
          if ( this.oPartyUser.IS_FIRSTLOGIN == 1 )
          {
            this.isfirstlogin = 1;
            this.router.navigateByUrl( 'userconfigration/changepassword' );
          }
          else
          {
            this.router.navigateByUrl( 'dashboard' );
          }
          //this.router.navigateByUrl('TrackBooking');

        }
        else {
          this.ErrorMessee = oServiceStatus.ErrorMessage;
          this.oApplicationcl.IsProgressBarEnable = false;
        }
      });
  }

  public ForgotPassword() {
    this.IsForgotPassword = true;
  }

  public ChangePassword() {
    if ( this.oForgotPassword.Password==undefined|| this.oForgotPassword.Password.length < 8) {
      alert("Password should be minimum 8 charecter.")
      return;
    }
    else if (this.oForgotPassword.Password != this.oForgotPassword.CPassword) {
      alert("Confirm password is invalid.")
      return;
    }
    else {
      this.oApplicationcl.IsProgressBarEnable = true;
      this.oForgotPassword.RequestSource = "ClientWebApp";
      this.oForgotPassword.MobileNo = this.oForgotPassword.Email;
      this._service.ChangePasswordBasic(this.oForgotPassword).subscribe(
        data => {
          this.oApplicationcl.IsProgressBarEnable = false;
          let oServiceStatus: ServiceStatus = data;
          if (oServiceStatus.Status == ResponseCode.Success.toString()) {
            alert(oServiceStatus.ErrorMessage);
            this.oForgotPassword = new ForgotPassword();
            this.IsForgotPassword = false;
            this.IsOTPReceived = false;
          }
          else {
            alert(oServiceStatus.ErrorMessage);
          }
        });
    }
  }


  GetOTP() {

    if (this.oForgotPassword.Email == undefined || this.oForgotPassword.Email == "") {
      alert("User name should not be blank.")
      return;
    }
    else {
      this.oForgotPassword.MobileNo = this.oForgotPassword.Email;
      this.oForgotPassword.RequestSource = "ClientWebApp";
      this._service.GetOTP( this.oForgotPassword ).subscribe(
        data => {
          this.oApplicationcl.IsProgressBarEnable = false;
          let oServiceStatus: ServiceStatus = data;
          if ( oServiceStatus.Status == ResponseCode.Success.toString()) {
            this.IsOTPReceived = true;
            this.timer = { s: 0, mn: 0 };
            setInterval(() => {
              this.timer.s += 1;
              if (this.timer.s > 59) {
                this.timer.s = 0;
                this.timer.mn += 1;
              }
              if (this.timer.mn == 3 && this.timer.s == 0) {
                this.timer = { s: 0, mn: 0 };
                this.IsOTPReceived = false;
              }
            }, 1000);
          }
          else {
            alert(oServiceStatus.ErrorMessage);
          }
        }
      );
    }
  }

  public CancelChangePassword() {
    this.oForgotPassword = new ForgotPassword();
    this.IsForgotPassword = false;
    this.IsOTPReceived = false;
  }
}
